// Single source of truth for "are we running inside the installed native app?".
// Used to hide purchase/registration calls-to-action that Apple/Google would
// block, WITHOUT changing the web experience (on web this is always false).
import { Capacitor } from '@capacitor/core';

export const isNativeApp = () => Capacitor.isNativePlatform();

// Where users are told to register/manage billing (native shows this as plain
// informational text — never a tappable purchase link, per App Store rules).
export const WEB_URL = 'micoach.tech';
